import { Box } from "@mui/material";
import AboutYourHealthScore from ".";
import theme from "@/theme";

export default function AboutYourHealthScoreExamples() {
  return (
    <Box bgcolor={theme.palette.primary.dark} p={2}>
      <AboutYourHealthScore healthScore={75} />
    </Box>
  );
}
